import React from 'react';
import pixelVerticalImage from "../images/pixel-vertical.svg"

export default function VerticalPixelImage() {
    return (
        <img
            className="pixel-vertical"
            src={pixelVerticalImage}
            alt="Imagen de un rectángulo en puntos color rojo."
        />
    );
}
